import type { IconName } from "../onboarding-chat";

const STROKE = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;

const PATHS: Record<IconName, JSX.Element> = {
  probe: <path d="M9 3h6l1 5a4 4 0 0 1-8 0zM12 13v8M9 21h6" />,
  scan: (
    <>
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  bolt: <path d="M13 2 3 14h9l-1 8 10-12h-9z" />,
  doc: (
    <>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6M9 15l2 2 4-4" />
    </>
  ),
  dollar: (
    <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  ),
  crm: (
    <path d="M20 7h-9M14 17H5M17 21a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM7 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
  ),
  people: (
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 7a4 4 0 1 0 0 .01" />
  ),
};

export const isKnownIcon = (name: IconName | undefined): name is IconName =>
  name !== undefined && name in PATHS;

export const Icon: FC<{ name: IconName; size?: number }> = ({
  name,
  size = 16,
}) =>
  PATHS[name] ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="presentation"
      {...STROKE}
    >
      {PATHS[name]}
    </svg>
  ) : null;

export const CheckIcon: FC<{ size?: number }> = ({ size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    role="presentation"
    {...STROKE}
    strokeWidth={2.5}
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);
